import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Fonts from './Fonts';
import './i18n';
import { ThemeProvider } from 'styled-components';
import { lightTheme, ModalProvider } from 'scorer-ui-kit';
import GlobalStyle from './style';
import { BrowserRouter as Router } from 'react-router-dom';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={lightTheme}>
      <ModalProvider>
        <Router>
          <App />
        </Router>
        <Fonts />
        <GlobalStyle />
      </ModalProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
